import React from "react"
import { MenuArrowProps } from "./types"
import styles from "./PullDown.module.css"

export const MenuArrow = ({ isOpen }: MenuArrowProps) => (
    <img
        src="/foodslaboEf/img/common/arrow.svg"
        alt="下矢印"
        className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}
    />
)
